import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

import TextField from 'components/fields/TextField';

import hexToRgb from 'styles/hexToRgb';

const styles = theme => ({
  root: {
    borderLeft: `1px solid ${theme.palette.primary.A400}`,
    padding: 0,
    verticalAlign: 'top',
    '&:first-child': {
      padding: 0,
      borderLeft: 'none',
    },
    '&:last-child': {
      padding: 0,
    },
  },
  rootFocused: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.1)`,
  },
  inputRoot: {
    width: '100%',
    border: 'none',
    borderRadius: 0,
    backgroundColor: 'transparent',
  },
});

class SchedulePreviewEditFormField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };

    this.onClick = this.onClick.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
  }

  onClick(event) {
    if (this.inputRef && this.inputRef !== event.target) {
      const position = this.inputRef
        ? this.inputRef.value.length
        : 0;
      this.inputRef.focus();
      this.inputRef.setSelectionRange(position, position);
    }
  }

  onInputFocus() {
    this.setState({ focused: true });
  }

  onInputBlur() {
    this.setState({ focused: false });
  }

  render() {
    const { className, name, classes } = this.props;
    const { focused } = this.state;

    return (
      <TableCell
        className={classNames(classes.root, className, {
          [classes.rootFocused]: focused,
        })}
        onClick={this.onClick}
      >
        <Field
          id={name}
          name={name}
          component={TextField}
          multiline
          fullWidth
          inputRootClassName={classes.inputRoot}
          size="sm"
          inputRef={(inputRef) => {
            this.inputRef = inputRef;
          }}
          onFocus={this.onInputFocus}
          onBlur={this.onInputBlur}
        />
      </TableCell>
    );
  }
}

SchedulePreviewEditFormField.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootFocused: PropTypes.string.isRequired,
    inputRoot: PropTypes.string.isRequired,
  }).isRequired,
};

SchedulePreviewEditFormField.defaultProps = {
  className: '',
};

export default withStyles(styles)(SchedulePreviewEditFormField);



// WEBPACK FOOTER //
// ./src/components/schedule/SchedulePreviewEditForm/SchedulePreviewEditFormField.js